import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import { dispatchOverlayLoad } from '../shared/Analytics';
import { PsBeaconButton, PsBeaconIcon } from '../shared/BeaconRegister';
import { retirementAdvisoryContent } from '../shared/Content';
import HubPageBase from './HubPageBase';
import ServiceInfoCard from '../../containers/ServiceInfoCard';
import { showModal } from '../../Utils';

const RasAccessChange = ({ state, dispatch }) => {
    const smallScreenSize = window.matchMedia('(max-width: 600px)');
    const [buttonSize, setButtonSize] = React.useState(
        window.innerWidth <= 600 ? '100%' : 'inherit'
    );

    smallScreenSize.addEventListener('change', function () {
        setButtonSize(smallScreenSize.matches ? '100%' : 'inherit');
    });

    const openAccountSelectionModal = (e) => {
        e.preventDefault();
        showModal('acct-selection');
        dispatchOverlayLoad('Primary Consent 1 Modal');
    };

    return (
        <HubPageBase state={state} dispatch={dispatch}>
            <Box sx={{ marginBottom: { xs: '-64px', md: '-160px' } }}>
                <Box
                    className="b-container-content"
                    sx={{ paddingTop: { xs: '24px', md: '64px' }, paddingBottom: '88px', inlineSize: 'unset !important' }}
                >
                    <Box sx={{ paddingRight: { md: '88px' } }}>
                        <Typography
                            id='ras-access-change-page-heading'
                            type="headline" serif loose scale={400}
                            sx={{ paddingBottom: '16px' }}
                        >
                            {retirementAdvisoryContent.rasAccessChange.heading}
                        </Typography>

                        <Typography id='ras-access-change-content-container' loose light>
                            <Box id='ras-access-change-content-1'>{retirementAdvisoryContent.rasAccessChange.content1}</Box>
                            <Box id='ras-access-change-content-2' sx={{ paddingTop: '48px', paddingBottom: '48px' }}>
                                {retirementAdvisoryContent.rasAccessChange.content2}
                            </Box>
                        </Typography>

                        <Typography
                            id='start-new-plan-heading'
                            type="headline" scale={100} bold
                            sx={{ paddingBottom: '16px' }}
                        >
                            {retirementAdvisoryContent.startNewPlan.heading}
                        </Typography>

                        <Typography id='start-new-plan-content-container' type="body" loose scale={100} light>
                            <Box id='start-new-plan-content-1'>{retirementAdvisoryContent.startNewPlan.content1}</Box>
                            <Box id='start-new-plan-content-2' sx={{ paddingTop: '48px' }}>
                                {retirementAdvisoryContent.startNewPlan.content2}
                            </Box>
                        </Typography>

                        <Box id='start-new-plan-button-container' sx={{ paddingTop: '24px', paddingBottom: '24px' }}>
                            <PsBeaconButton
                                id='start-new-plan-button'
                                scale="jumbo"
                                style={{ width: buttonSize, whiteSpace: 'nowrap' }}
                                onclick={openAccountSelectionModal}
                            >
                                Start a New Plan
                                <PsBeaconIcon slot='suffix' name='chevron_right' style={{ paddingTop: '2px' }} />
                            </PsBeaconButton>
                        </Box>
                    </Box>
                </Box>
                <Box>
                    <ServiceInfoCard />
                </Box>
            </Box>
        </HubPageBase>
    );
};

export default RasAccessChange;
